import { ModuleWithProviders } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UserListComponent } from './carefinity/views/user/list/user-list.component'

import { AppMainComponent } from './app.main.component'
import { AppointmentsListComponent } from './carefinity/views/appointments/appointments-list/appointments-list.component'
import { DecryptconnectionStringsComponent } from './carefinity/views/global-settings/decryptconnection-strings/decryptconnection-strings.component'
import { EmergencyTokenComponent } from './carefinity/views/global-settings/emergency-token/emergency-token.component'
import { PatientDemographicsComponent } from './carefinity/views/global-settings/patient-demographics/patient-demographics.component'
import { AppLoginComponent } from './carefinity/views/login/app.login.component'
import { AddNotesComponent } from './carefinity/views/manage-notes/add/add-notes.component'
import { EditNoteResolverService } from './carefinity/views/manage-notes/edit/edit-note-resolver.service'
import { EditNoteComponent } from './carefinity/views/manage-notes/edit/edit-note.component'
import { ManageNotesComponent } from './carefinity/views/manage-notes/list/manage-notes.component'
import { ManageQuestionsComponent } from './carefinity/views/manage-questions/manage-questions.component'
import { QuestionResolverService } from './carefinity/views/manage-questions/question-resolver.service'
import { ResetPasswordComponent } from './carefinity/views/password-reset/reset-password/reset-password.component'
import { ResetUserPasswordComponent } from './carefinity/views/password-reset/reset-user-password/reset-user-password.component'
import { PatientArchiveComponent } from './carefinity/views/patient-archive/patient-archive.component'
import { PatientListComponent } from './carefinity/views/patient/patient-list/patient-list.component'
import { QuestionAnswerResolverService } from './carefinity/views/question-answer/question-answer-resolver.service'
import { QuestionAnswerComponent } from './carefinity/views/question-answer/question-answer.component'
import { AddReportsComponent } from './carefinity/views/reports/add/addReports.component'
import { EditReportComponent } from './carefinity/views/reports/edit/edit-report.component'
import { ListReportComponent } from './carefinity/views/reports/list/list-reports.component'
import { ReportparamAddComponent } from './carefinity/views/reports/report-param/reportparam-add/reportparam-add.component'
import { ReportparamEditComponent } from './carefinity/views/reports/report-param/reportparam-edit/reportparam-edit.component'
import { ReportparamListComponent } from './carefinity/views/reports/report-param/reportparam-list/reportparam-list.component'
import { ReportsCategoryComponent } from './carefinity/views/reports/reports-category/reports-category.component'
import { SelectPracticeComponent } from './carefinity/views/select-practice/select-practice.component'
import { CreateUserComponent } from './carefinity/views/user/create/create-user.component'
import { GroupResolver } from './carefinity/views/user/create/group-resolver.service'
import { UserResolverService } from './carefinity/views/user/create/user-resolver.service'
import { UserPracticesComponent } from './carefinity/views/userpractices/user-practices.component'
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component'
import { AppErrorComponent } from './pages/app.error.component'
import { AppNotfoundComponent } from './pages/app.notfound.component'
//import { TasksListComponent } from './carefinity/views/tasks/tasks-list/tasks-list.component';
import { AllergyListComponent } from './carefinity/views/patient/allergy-list/allergy-list.component'
import { BillingListComponent } from './carefinity/views/patient/billing/billing-list/billing-list.component'
import { DashboardComponent } from './carefinity/views/patient/dashboard/dashboard.component'
import { CatDocumentComponent } from './carefinity/views/patient/document/cat-document/cat-document.component'
import { DocumentListComponent } from './carefinity/views/patient/document/document-list/document-list.component'
import { ExportDocumentComponent } from './carefinity/views/patient/export-document/export-document.component'
import { FinancialDetailsComponent } from './carefinity/views/patient/financial/financial-details/financial-details.component'
import { FinancialListComponent } from './carefinity/views/patient/financial/financial-list/financial-list.component'
import { ListComponent } from './carefinity/views/patient/images/list/list.component'
import { LabDetailsComponent } from './carefinity/views/patient/lab-list/lab-details/lab-details.component'
import { LabListComponent } from './carefinity/views/patient/lab-list/lab-list.component'
import { MedicationListComponent } from './carefinity/views/patient/medication-list/medication-list.component'
import { NotesComponent } from './carefinity/views/patient/notes/notes.component'
import { OrderListComponent } from './carefinity/views/patient/order/order-list/order-list.component'
import { ProblemListComponent } from './carefinity/views/patient/problem-list/problem-list.component'
import { SigListComponent } from './carefinity/views/patient/significantEvents/sig-list/sig-list.component'
import { VisitsListComponent } from './carefinity/views/patient/visits-list/visits-list.component'
import { VitalListComponent } from './carefinity/views/patient/vitals/vital-list/vital-list.component'
import { AuthGuard } from './carefinity/services/auth-guard'
import { CellverificationComponent } from './carefinity/views/Twofactor/cellverification/cellverification.component'
import { ChangePasswordComponent } from './carefinity/views/forgot-password/change-password/change-password.component'
import { EnterTokenComponent } from './carefinity/views/forgot-password/enter-token/enter-token.component'
import { ForceChangePasswordComponent } from './carefinity/views/forgot-password/force-password-change/force-password-change.component'
import { QuestionListComponent } from './carefinity/views/forgot-password/question-list/question-list.component'
import { RolesListComponent } from './carefinity/views/manage-roles/roles-list/roles-list.component'
import { RestorePatientComponent } from './carefinity/views/patient/restore-patient/restore-patient.component'
import { RefreshReportsComponent } from './carefinity/views/reports/refresh-reports/refresh-reports.component'
import { ReportViewComponent } from './carefinity/views/reports/report-view/report-view.component'
import { ReportsViewListComponent } from './carefinity/views/reports/reports-view-list/reports-view-list.component'
import { ManagerolesComponent } from './carefinity/views/user/manageroles/manageroles.component'
import { UserprofileComponent } from './carefinity/views/user/userprofile/userprofile.component'
import { licenseCheckResolver } from './license-check.resolver'
import { AppMFAComponent } from './pages/app.mfa.component'
import { AppSamlAuthenticationComponent } from './pages/app.samlAuthentication.component'
import { RegisterComponent } from './pages/register/register.component'
import { SesssionTimedComponent } from './pages/timedout.component'
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component'
import { PracticeSettingsComponent } from './carefinity/views/practice-settings/practice-settings.component'
import { ApplicationConfigComponent } from './carefinity/views/application-config/application-config.component'
import { AppComponent } from './app.component'
import { MaintainencePageComponent } from './carefinity/views/maintainence-page/maintainence-page.component'
import { GlobalMappingSettingComponent } from './carefinity/views/global-mapping-setting/global-mapping-setting.component'
import { CatImageComponent } from './carefinity/views/patient/images/cat-image/cat-image.component'
import { ImagesWrapperComponent } from './carefinity/views/patient/images/images-wrapper/images-wrapper.component'
import { ExportClinicalDataComponent } from './carefinity/views/patient/export-clinical-data/export-clinical-data.component'
import { TimelineComponent } from './timeline/timeline.component'
import { ApiKeysComponent } from './carefinity/views/api-keys/api-keys.component'
import { preferencesResolver } from './carefinity/resolvers/resolvers'
import { UserPreferenceSettingComponent } from './carefinity/views/user-preference-setting/user-preference-setting.component'
import { AddInsuranceComponent } from './carefinity/views/patient/add-insurance/add-insurance.component'
import { AppMainComponentSSO } from './app.main.componentSSO'


const showPDFRoute = [
    {
        path: 'show-pdf',
        component: PdfViewerComponent,
    },
]

const showPDFRouteWithId = [
    {
        path: 'show-pdf/:id',
        component: PdfViewerComponent,
    },
]


export const routes: Routes = [
    {
        title: 'Login | CareFinity',
        path: '',
        pathMatch: 'full',
        redirectTo: '/login',
    },


    {
        component: AppMainComponentSSO,
        path: '',
        canActivate: [AuthGuard],

        children: [
            {
                path: 'patientsearchsso',
                title: 'patient Search',
                component: PatientListComponent,
                canActivate: [AuthGuard],
            }

        ]

    },

    {
        component: AppMainComponent,
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: 'administration',
                children: [
                    {
                        path: 'user-list',
                        title: 'User List',
                        component: UserListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'user-profile',
                        title: 'User Profile',
                        component: UserprofileComponent,
                    },
                    {
                        path: 'practice-config',
                        title: 'Practice Settings Component',
                        component: PracticeSettingsComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'global-config',
                        title: 'Global Settings Component',
                        component: ApplicationConfigComponent,
                        canActivate: [AuthGuard],
                    },

                    {
                        path: 'patientsearch',
                        title: 'patient Search',
                        component: PatientListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Users Practice',
                        path: 'users-practice',
                        component: UserPracticesComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Reset Password',
                        path: 'reset-password-group',
                        component: ResetPasswordComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Change Password',
                        path: 'change-password',
                        component: ResetUserPasswordComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Security Token',
                        path: 'security-token',
                        component: EmergencyTokenComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Patient Demographics',
                        path: 'patient-demographics',
                        component: PatientDemographicsComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Report Categories',
                        path: 'report-categories',
                        component: ReportsCategoryComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Manage Reports',
                        path: 'manage-reports',
                        component: ListReportComponent,
                        canActivate: [AuthGuard],
                    },


                    {
                        title: 'Manage Roles',
                        path: 'manage-roles',
                        component: RolesListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Manage Roles',
                        path: 'upsert-roles',
                        component: ManagerolesComponent,
                    },
                    {
                        path: 'add-reports',
                        title: 'Add Reports',
                        component: AddReportsComponent,
                    },
                    { path: 'edit-reports', component: EditReportComponent },

                    {
                        path: 'manage-notes',
                        title: 'Manage Notes',
                        component: ManageNotesComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'reports-param',
                        title: 'Reports Param',
                        component: ReportparamListComponent,
                    },
                    {
                        path: 'add-paramreports',
                        title: 'Add Paramreports',
                        component: ReportparamAddComponent,
                    },
                    {
                        path: 'edit-paramreports',
                        title: 'Edit Paramreports',
                        component: ReportparamEditComponent,
                    },

                    {
                        title: 'Add Notes',
                        path: 'add-notes/:category_id/:category_name/:note_id',
                        resolve: { notes_template: EditNoteResolverService },
                        component: AddNotesComponent,
                    },

                    {
                        title: 'Edit Notes',
                        path: 'edit-notes/:note_id',
                        resolve: { notes_template: EditNoteResolverService },
                        component: EditNoteComponent,
                    },
                    {
                        path: 'patient-archive',
                        component: PatientArchiveComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'listmapping',
                        title: 'List Global Mapping Setting',
                        component: GlobalMappingSettingComponent,
                        canActivate: [AuthGuard],
                    },
                    //{
                    //    path: 'manage-questions',
                    //    title: 'manage-questions',
                    //    resolve: { questionList: QuestionResolverService },
                    //    component: ManageQuestionsComponent,
                    //    runGuardsAndResolvers: 'always'
                    //},

                    {
                        path: 'manage-questions',
                        title: 'Manage Questions',
                        resolve: { questionList: QuestionResolverService },
                        component: ManageQuestionsComponent,
                        canActivate: [AuthGuard],
                    },



                    {
                        path: 'create_user/:practice_id/:userid',
                        title: 'Create User',
                        component: CreateUserComponent,
                        resolve: { groups: GroupResolver, user: UserResolverService },
                    },
                    {
                        title: 'connectionstrings',
                        path: 'connectionstrings',
                        component: DecryptconnectionStringsComponent,
                       canActivate: [AuthGuard],
                    },
                    {
                        title: 'DecryptConnectionString',
                        path: 'DecryptConnectionString',
                        component: DecryptconnectionStringsComponent,
                        // canActivate: [AuthGuard],
                    },

                    {
                        path: 'show-pdf',
                        component: PdfViewerComponent,
                    },
                    {
                        path: 'api_keys',
                        title: 'Create Api Keys',
                        component: ApiKeysComponent,
                        canActivate: [AuthGuard],
                    },
                ],
            },


            //{
            //  title: 'Reports View',
            //  path: 'category-reports-view',
            //  component: ReportsViewListComponent,
            //  /*, canActivate: [AuthGuard] */
            //  children: [...showPDFRoute],
            //  },

            {
                title: 'View Reports',
                path: 'ViewReports',
                children: [
                    {
                        title: 'Reports View',
                        path: 'category-reports-view/:id',
                        component: ReportsViewListComponent,
                        canActivate: [AuthGuard],
                        children: [...showPDFRoute],
                    },
                ],
            },

            //{
            //    title: 'Reports View',
            //    path: 'reports-view',
            //    component: ReportViewComponent,
            //    /*, canActivate: [AuthGuard] */
            //    children: [...showPDFRoute],
            //},

            {
                title: 'View Reports',
                path: 'Patient',
                children: [
                    {
                        title: 'Reports View',
                        path: 'reports-view/:id',
                        component: ReportViewComponent,
                        /*canActivate: [AuthGuard],*/
                        children: [...showPDFRoute],
                    },
                ],
            },

            {
                title: 'settings',
                path: 'settings',
                children: [
                    {
                        path: 'change-password',
                        title: 'Change Password',
                        component: ResetUserPasswordComponent,
                        canActivate: [AuthGuard],
                    },
                ],
            },

            {
                title: 'User Perf',
                path: 'settings',
                children: [
                    {
                        path: 'user-pref',
                        title: 'user-pref',
                        component: UserPreferenceSettingComponent,
                        //canActivate: [AuthGuard],
                    },
                ],
            },

            {
                path: 'patient',
                children: [
                    {
                        path: 'patient-search',
                        title: 'Patient Search',
                        component: PatientListComponent,
                        canActivate: [AuthGuard],
                    },
                ],
            },
            {
                path: 'appointment',
                canActivate: [AuthGuard],
                children: [
                    {
                        path: 'list',
                        title: 'Appointment List',
                        component: AppointmentsListComponent,
                    },
                ],
            },

            {
                path: 'Patient',
                children: [
                    {
                        path: 'show-pdf',
                        component: PdfViewerComponent,
                    },
                    {
                        title: 'Dashboard',
                        path: 'dashboard',
                        component: DashboardComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Dashboard',
                        path: 'dashboard/:id',
                        component: DashboardComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Allergy',
                        path: 'allergy/list',
                        component: AllergyListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Problems',
                        path: 'problems/list',
                        component: ProblemListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Medications',
                        path: 'medication/list',
                        component: MedicationListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'List Visits',

                        path: 'visits/list',
                        component: VisitsListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Orders List',
                        path: 'orders/list',
                        component: OrderListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Images List',
                        path: 'images/list',
                        component: ImagesWrapperComponent,
                        canActivate: [AuthGuard],
                        children: [...showPDFRoute],
                    },
                    {
                        title: 'Documents List',
                        path: 'documents/list',
                        component: DocumentListComponent,
                        canActivate: [AuthGuard],

                        children: [...showPDFRoute],
                    },
                    {
                        title: 'Documents Catlist',
                        path: 'documents/catlist',
                        component: CatDocumentComponent,
                        canActivate: [AuthGuard],
                        children: [...showPDFRoute],
                    },
                    {
                        title: 'Labs List',
                        path: 'labs/list',
                        component: LabListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Labs Details',
                        path: 'labs/details',
                        component: LabDetailsComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Events List',
                        path: 'events/list',
                        component: SigListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Financial List',
                        path: 'financial/list',
                        component: FinancialListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Financial Details',
                        path: 'financial/details',
                        component: FinancialDetailsComponent,
                        //  canActivate: [AuthGuard],
                    },
                    {
                        title: 'Billing List',
                        path: 'billing/list',
                        component: BillingListComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Vitals List',
                        path: 'vitals/list',
                        component: VitalListComponent,
                    },
                    {
                        title: 'Patient',
                        path: 'restore',
                        component: RestorePatientComponent,
                    },
                    {
                        title: 'Export Documents List',
                        path: 'exportdocuments/list',
                        component: ExportDocumentComponent,
                        canActivate: [AuthGuard],
                        children: [...showPDFRoute],
                    },
                    {
                        title: 'Notes Manage',
                        path: 'notes/manage',
                        component: NotesComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        title: 'Patient Timeline',
                        path: 'timeline',
                        component: TimelineComponent,
                        canActivate: [AuthGuard],
                        children: [...showPDFRouteWithId],
                        resolve: { preferences: preferencesResolver }
                    },
                    {
                        title: 'export Data',
                        path: 'export',
                        component: ExportClinicalDataComponent,
                       // canActivate: [AuthGuard],
                    }
                ],
            },
        ],
    },

    { path: 'RefreshComponent', component: RefreshReportsComponent },



    {
        title: 'Patient Answer Questions',
        path: 'Patient/answer_questions',
        resolve: { question_list: QuestionAnswerResolverService },
        component: QuestionAnswerComponent,
    },

    {
        title: 'Forgot Password',
        path: 'Patient/Forgot-Password',
        component: QuestionListComponent,
    },
    {
        title: 'Validate token',
        path: 'Validate-token',
        component: EnterTokenComponent,
    },
    {
        title: 'Forgot Pwd Change',
        path: 'Forgotpwd-change',
        component: ChangePasswordComponent,
    },

    {
        title: 'Force Reset Password',
        path: 'force-reset-password',
        component: ForceChangePasswordComponent,
    },
    {
        title: 'Patient Cell Verification',
        path: 'Patient/cell-verification',
        component: CellverificationComponent,
    },
    { title: 'error', path: 'error', component: AppErrorComponent },
    { title: 'mfa', path: 'mfa', component: AppMFAComponent },
    {
        title: 'Validate Code',
        path: 'validate Code',
        component: AppMFAComponent,
        data: { doNotLoginAfterValidationSucceeded: true },
    },
    {
        path: 'select-practice',
        component: SelectPracticeComponent,
        title: 'Select Practice',
        canActivate: [AuthGuard],
    },
    {
        title: 'Sesssion Timeout',
        path: 'sesssionTimeout',
        component: SesssionTimedComponent,
    },
    {
        title: 'Sesssion Ended',
        path: 'sesssionEnded',
        component: SesssionTimedComponent,
    },

    {
        title: 'Access Denied',
        path: 'accessdenied',
        component: AppAccessdeniedComponent,
    },
    { title: 'Not Found', path: '404', component: AppNotfoundComponent },
    { title: 'Register', path: 'register', component: RegisterComponent },
    {
        title: 'Login | CareFinity',
        path: 'login',
        component: AppLoginComponent,
        pathMatch: 'full',
        resolve: { licenseCheck: licenseCheckResolver },
    },
    {
        title: 'Saml Authentication',
        path: 'saml',
        component: AppSamlAuthenticationComponent,
        pathMatch: 'full',
        resolve: { licenseCheck: licenseCheckResolver },
    },
    {
        title: 'Carefinity Maintenance',
        path: 'underConstruction',
        component: MaintainencePageComponent,
    },

    {
        title: 'Add Insurance',
        path: 'insurace',
        component: AddInsuranceComponent,
    }

    /*    { title: 'Not Found', path: '**', redirectTo: '/404' },
     */
]

export const AppRoutes: ModuleWithProviders<RouterModule> =
    RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled' // Enables anchor link scrolling

    })
